import React from 'react';
import '../../less/bootstrap.less'
import './HeaderInvoice.css';

export type FooterInvoiceProps = {
    readonly country: string
}

export class FooterInvoice extends React.Component<FooterInvoiceProps> {
    render() {
        const publicUrl = process.env.REACT_APP_REDIRECT_URL ? process.env.REACT_APP_REDIRECT_URL : '';
        const hrefLink = publicUrl + '/privacy/'+ this.props.country;
        return (
            <div className='ng-scope'>
                <div className='footer' style={{minHeight: '150px'}}>
                    <div className='privacy-desktop'>
                        <a target='_blank' rel='noopener noreferrer' href={hrefLink}>View our privacy policy</a>
                    </div>
                </div>
            </div>
        )
    }
}

export default FooterInvoice;

